import { createSlice } from "@reduxjs/toolkit";
import {  searchNonprofitsAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const searchNonprofitSlice = createSlice({
  name: "searchNonprofit",
  initialState: data,
  reducers: {
    searchNonprofitSlice(state) {
      state.isLoading = false;
    },
    searchNonprofitSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    searchNonprofitSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    searchNonprofitSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const searchNonprofitHandler = (search:string,zipCodeVal:any) => async (dispatch: any) => {
  try {
    dispatch(searchNonprofitAction.searchNonprofitSlice());
    const response: any = await searchNonprofitsAPI(search,zipCodeVal);
    dispatch(searchNonprofitAction.searchNonprofitSliceSuccess(response));
  } catch (e: any) {
    dispatch(searchNonprofitAction.searchNonprofitSliceFailure(e?.response?.data?.message));
  }
};
export default searchNonprofitSlice.reducer;
export const searchNonprofitAction = searchNonprofitSlice.actions;
